export default __webpack_public_path__ + "static/media/016-speed limit.96587810.png";